import React, { forwardRef } from 'react';

import DataCollection from '@storefront/services/DataCollection';
import { uiEvents } from '@storefront/services/DataCollection/simpleUiEvents';
import TranslatedText from '@storefront/shared-components/translated-text/translated-text';

import styles from './plan-card.module.scss';

export type PlanCardType = {
  text: string;
  color: string;
  title: string;
  icon: React.ReactNode;
  list?: string[];
  extraContent?: string;
};

const PlanCard = forwardRef<HTMLDivElement, PlanCardType>((props, ref) => {
  const { text, color, title, icon, list, extraContent } = props;
  const translatedComponents = {
    learnMore: {
      href: 'https://h20195.www2.hp.com/v2/getpdf.aspx/4aa8-3539enus.pdf',
      id: 'learn-more-replacement',
      onClick: async () => {
        await DataCollection.sendEvent(uiEvents.printerHowItWorksBC, {
          controlDetail:
            'https://h20195.www2.hp.com/v2/getpdf.aspx/4aa8-3539enus.pdf',
        });
      },
    },
  };

  return (
    <div
      className={styles['container']}
      style={{ backgroundColor: color }}
      ref={ref}
    >
      <div className={styles['icon']}>{icon}</div>
      <div className={`${styles['title']} title-small`}>{title}</div>
      <div className={`${styles['text']} body-large`}>
        <TranslatedText
          linkStyle="black"
          i18nKey={text}
          links={translatedComponents}
        />
      </div>
      {list && (
        <div className={styles['styled-list']}>
          <ul>
            {list.map((item: string) => (
              <li key={item} className="body-large">
                {item}
              </li>
            ))}
          </ul>
        </div>
      )}
      {extraContent && (
        <p className={'body-large'}>
          <TranslatedText
            linkStyle="black"
            i18nKey={extraContent}
            links={translatedComponents}
          />
        </p>
      )}
    </div>
  );
});
//Necessary attribute because of the use of the forwardRef
PlanCard.displayName = 'PlanCard';
export default PlanCard;
